import cx from 'clsx';
import { Text } from '@paylink/constants';

import { Button, InputBase } from '@shared/components/core';

import { IInputCardProps } from './InputCard.types';
import styles from './InputCard.module.scss';

const InputCard = ({
	title,
	subtitle,
	label = Text.MOBILE_LABEL,
	phoneError,
	phone,
	placeholder = Text.MOBILE_PLACEHOLDER,
	cardClassName,
	isMobile = false,
	isPaylinkVerifying,
	handlePhoneInput,
	handleVerifyPhone,
	handleKeyDown,
}: IInputCardProps) => {
	const inputCardContent = (
		<>
			<div
				className={cx('d-flex flex-column width100  px4  gap1', {
					'pt4 pb3': isMobile,
					py0: !isMobile,
				})}
			>
				<p
					className={cx('mt0 mb0 bolder dark3', {
						'h2 lh1': !isMobile,
						'h4 lh3': isMobile,
					})}
				>
					{title}
				</p>
				<p
					className={cx('mt0 mb0 lighter grey6', {
						'lh5 h5': isMobile,
						'h4 lh3': !isMobile,
					})}
				>
					{subtitle}
				</p>
			</div>

			<div
				className={cx(
					'd-flex flex-column bg-white width100',
					{
						[styles.formCard]: !isMobile,
						'card-shadow1 border1 border-radius4 grey1 gap10': !isMobile,
					},
					cardClassName,
				)}
			>
				<InputBase
					label={!isMobile ? label : undefined}
					prefix={
						<span
							className={cx(
								'd-flex items-center justify-center px1 py1 ml1 h4 dark3 border-radius1 lighter',
								styles.countryCode,
							)}
						>
							{Text.COUNTRY_CODE}
						</span>
					}
					type="tel"
					placeholder={placeholder}
					onChange={handlePhoneInput}
					onKeyDown={handleKeyDown}
					maxLength={10}
					value={phone}
					className={cx('width100 p2')}
					errorMessage={phoneError}
					disabled={isPaylinkVerifying}
					showError
				/>

				<Button
					disabled={isPaylinkVerifying}
					variant="primary"
					onClick={handleVerifyPhone}
					className={cx('width100 border-radius2 p4', styles.verifyBtn)}
				>
					{Text.VERIFY}
				</Button>
			</div>
		</>
	);
	return isMobile ? (
		<div
			className={cx(
				'border-top-radius4  relative bg-white card-shadow2',
				styles.inputCardWrapperMobile,
			)}
		>
			{inputCardContent}
		</div>
	) : (
		inputCardContent
	);
};

export default InputCard;
